export default __webpack_public_path__ + "static/media/FrozenABC_11.1cd36659.png";